import { usePermissions } from '@flash-tecnologia/hros-web-utility';

const withAdminPermission =
  <P extends object>(WrappedComponent: React.ComponentType<P>) =>
  ({ ...props }) => {
    const { isAdmin } = usePermissions();
    return isAdmin ? <WrappedComponent {...(props as P)} /> : false;
  };

export { withAdminPermission };
